import { env } from "./env";
import type { LineIdentity } from "./types";

export interface AttendanceIdentityProvider {
  getIdentity(): Promise<LineIdentity>;
}

class DevelopmentIdentityProvider implements AttendanceIdentityProvider {
  async getIdentity(): Promise<LineIdentity> {
    const devLineUserId = localStorage.getItem("attendance.devLineUserId") || env.devLineUserId;
    return { mode: "development", devLineUserId, displayName: "Development LINE User" };
  }
}

class LiffIdentityProvider implements AttendanceIdentityProvider {
  async getIdentity(): Promise<LineIdentity> {
    if (!env.lineLiffId) throw new Error("VITE_LINE_LIFF_ID is required in LINE mode");
    const { default: liff } = await import("@line/liff");
    await liff.init({ liffId: env.lineLiffId });
    if (!liff.isLoggedIn()) {
      liff.login({ redirectUri: window.location.href });
      throw new Error("กำลังเชื่อมต่อ LINE Login");
    }
    const idToken = liff.getIDToken();
    if (!idToken) throw new Error("LINE ไม่ได้ส่ง ID token กรุณาเปิดจาก Rich Menu อีกครั้ง");
    const profile = await liff.getProfile();
    return { mode: "line", idToken, displayName: profile.displayName };
  }
}

export const identityProvider: AttendanceIdentityProvider = env.lineMode === "line" ? new LiffIdentityProvider() : new DevelopmentIdentityProvider();

export function setDevelopmentLineUserId(value: string) {
  localStorage.setItem("attendance.devLineUserId", value.trim());
}
